export const useStyles = () => ({
  root: {
    '& > #gamecastVideoTag': {
      position: 'fixed !important',
      height: '100% !important',
      visibility: 'hidden',
      background: '#000000',
    },
  },
});
